
////////////////////////////////////
// M038 foodtruck calculator

function getCurrentData() {
    var currentObject = undefined;
    if (window.salesTruckCalc && window.salesTruckCalc.type) {
        currentObject = window.salesTruckCalc;
    }
    else if (window.foodTruckCalc && window.foodTruckCalc.translatedTexts) {
        currentObject = window.foodTruckCalc;
    }
    return currentObject;
}

function initFoodtruckCalculator() {
    var $moduleContainer = $(".foodtruckCalculator");
    var lang = "de-DE";
    var dataContainerObj = undefined;
    if ($moduleContainer.length) {

        dataContainerObj = getCurrentData();

        window.foodTruckCalc && (window.foodTruckCalc = $.extend(window.foodTruckCalc, {
            kasko500: {
                value: '',
                currency: '',
                factor: {
                    en: 2.9,
                    de: 2.9
                }
            },
            kasko1000: {
                value: '',
                currency: '',
                factor: {
                    en: 2.3,
                    de: 2.3
                }
            },
            totals: {
                kasko: 0,
                options: 0
            },
            getType: function () {
                return this.lang;
            },
            getLang: function () {
                return this.lang;
            },
            getCurrency: function () {
                return this.currency;
            }
        }));

        window.salesTruckCalc && (window.salesTruckCalc = $.extend(window.salesTruckCalc, {
                kasko500: {
                    value: '',
                    currency: '',
                    factor: {
                        imbiss: 3.3,
                        withFire: 2.8,
                        noFire: 2.42
                    }
                },
                kasko1000: {
                    value: '',
                    currency: '',
                    factor: {
                        imbiss: 2.6,
                        withFire: 2.3,
                        noFire: 1.87
                    }
                },
                totals: {
                    kasko: 0,
                    options: 0
                },
                getType: function () {
                    return this.type;
                },
                getCurrency: function () {
                    return this.currency;
                },
                getLang: function () {
                    return "de";
                }
            })
        );


        $($moduleContainer).find('.match_h').matchHeight({target: $('.match_h_target')});

        if ($($moduleContainer).length > 0) {

            //to be replaced by translated inline script variables.
            var $page1 = $('#formPage1');
            var $page2 = $('#formPage2');
            var $page3 = $('#formPage3');

            //page1 continue
            $($page1).find('button.next').on('click', function () {
                $($page1).hide();
                if($page2.length != 0){
                    $($page2).show();

                    //tracking
                    if($moduleContainer.hasClass("salesTruck")){
                        trackEvent("verkaufswagen_step_insurancetype", "");
                    }
                    else{
                        trackEvent("foodtruck_step_insurancetype", "");
                    }
                }
                else{
                    $($page3).show();

                    //tracking
                    if($moduleContainer.hasClass("salesTruck")){
                        trackEvent("verkaufswagen_step_personaldata", _foodtruckAnnualTotal);
                    }
                    else{
                        trackEvent("foodtruck_step_personaldata", _foodtruckAnnualTotal);
                    }
                }
                $('body, html').animate({scrollTop: $($moduleContainer).offset().top}, 500);
            });
            //page2 back
            $($page2).find('button.prev').on('click', function () {
                $($page2).hide();
                $($page1).show();
                $('body, html').animate({scrollTop: $($moduleContainer).offset().top}, 500);
            });
            //page2 continue
            $($page2).find('button.next').on('click', function () {
                $($page2).hide();
                $($page3).show();
                $('body, html').animate({scrollTop: $($moduleContainer).offset().top}, 500);

                //tracking
                if($moduleContainer.hasClass("salesTruck")){
                    trackEvent("verkaufswagen_step_personaldata", _foodtruckAnnualTotal);
                }
                else{
                    trackEvent("foodtruck_step_personaldata", _foodtruckAnnualTotal);
                }
            });
            //page3 cancel
            $($page3).find('button.cancel').on('click', function () {
                $($page3).hide();
                $($page1).show();
                // reset form?
                $('body, html').animate({scrollTop: $($moduleContainer).offset().top}, 500);
                $('body, html').animate({scrollTop: $($moduleContainer).offset().top}, 500);
            });

            /**
             * page1
             */

            if ($('input[data-group-id=salesTruckType]').length) {
                $('#inputValueFoodtruck, #inputValueFoodtruckContent, input[data-group-id=inputDailyCost]').prop('disabled', true);
                $('input[data-group-id=salesTruckType]').on('change paste keyup input', function () {
                    dataContainerObj.type = $(this).first().val();
                    $('#inputValueFoodtruck, #inputValueFoodtruckContent, input[data-group-id=inputDailyCost]').prop('disabled', false);
                    updateOnFirstPageChange();
                })
            }
            $('#calcMonthlySelect').find('input').prop('disabled', true);


            $('#inputValueFoodtruck, #inputValueFoodtruckContent, input[data-group-id=inputDailyCost]')
                .on('change paste keyup input', function () {
                    updateOnFirstPageChange();
                });

            $('#calcMonthlySelect').find('input').on('change', function (evt) {
                updateOnPremiumSelect($(this));
            });

            /**
             * page2
             */

            $('.ftcOptionsCheckbox').on('change', updateOnSecondPageChange);

            /** upload formfield text on change*/
            var $foodtruckForm = $('.foodtruckCalculator form');

            $($foodtruckForm).find("input[type='file']").each(function (idx, el) {
                $(el).on('change', function () {
                    var $replaceText = $(this).next('label').find('.uploadFileElement');
                    if ($(this)[0].files.length) {
                        $($replaceText).html($(this)[0].files[0].name);
                    }
                    else {
                        $($replaceText).html(ftc_tr.chooseFileText);
                    }
                });
            });

            $($foodtruckForm).find('#einwilligen').change(function () {
                if ($(this).prop('checked')) {
                    $($foodtruckForm).find('.submitButton').prop('disabled', false);
                }
                else {
                    $($foodtruckForm).find('.submitButton').prop('disabled', true);
                }

            });

            //file upload fields per json
            if ($('.fileUpload').length > 0) {
                fileUpload();
            }

            /** Validation of date input to text field */
            var checkNumbers = function ($input, maxNum, maxLength) {
                if (parseInt($($input).val()) > maxNum) {
                    $($input).val(maxNum);
                }

                if (parseInt($($input).val()).length > maxLength) {
                    $($input).val(maxNum);
                }
            };
            var checkDates = function () {
                var $formFields = $('.form-field');

                $($formFields).filter(function () {
                        return $(this).hasClass('checkDateDay')
                    }
                ).on('keyup', function (evt) {

                    var $input = $(this).find('input');

                    if (!parseInt(event.key)) {
                        $($input).val($input.val().replace(/\D/g, ''));
                        checkNumbers($input, 31, 3)
                    }
                    else {
                        checkNumbers($input, 31, 3)

                    }
                });

                $($formFields).filter(function () {
                        return $(this).hasClass('checkDateYear')
                    }
                ).on('keyup', function (evt) {

                    var $input = $(this).find('input');

                    if (!parseInt(event.key)) {
                        $($input).val($input.val().replace(/\D/g, ''));
                        checkNumbers($input, 2100, 5)
                    }
                    else {
                        checkNumbers($input, 2100, 5)

                    }
                });
            }();
        }

        //fade in calculator after initialization
        $moduleContainer.addClass("foodtruckCalculator--visible");

        function updateCalculationSummary() {
            var $calcSumContainer = $('.calcSummary');
            var totals = dataContainerObj.totals;
            var annualTotal = parseFloat(totals.options) + parseFloat(totals.kasko * 12);
            $($calcSumContainer).find('.calcAnnual .totalAmount').html(formatNumberToCurrency(annualTotal, 'symbol', dataContainerObj.getLang(), dataContainerObj.getCurrency() ));
            $($calcSumContainer).find('.calcMonthly .totalAmount').html(formatNumberToCurrency((annualTotal / 12),  'symbol', dataContainerObj.getLang(), dataContainerObj.getCurrency() ));

            var $form = $('.foodtruckCalculator form');
            $($form).find('#total-month').val(  Math.round( (annualTotal / 12) * 100 )/100  );
            $($form).find('#total-year').val( Math.round( annualTotal * 100)/100);

            _foodtruckAnnualTotal = annualTotal;
        }

        /**
         * Defaults to german symbol,
         * returns text string if float cannot be parsed.
         * */
        function formatNumberToCurrency(input, display, country, currency) {
            var float, output, thousand, decimal, format;
            country = country || "de-DE";
            currency = currency || '€';
            display = display || 'symbol';

            //console.log("formatNumberToCurrency # input:" + input + " # display:" + display + " # country:" + country + " # currency:" + currency);

            //manually set separators.
            if (("ch-CH" === country) || ("ch" === country) || ("CHF" === currency)) {
                thousand = '‘';
                decimal = '.';
                format = "%s %v";
            }
            else if (("de-DE" === country) || ("de" === country)) {
                thousand = '.';
                decimal = ',';
                format = "%v %s";
            }
            else {
                thousand = ',';
                decimal = '.';
                format = "%s %v";
            }
            //if output is text string give it back, else try to format as
            // currency;
            if (!isNaN((float = parseFloat(input)))) {
                output = accounting.formatMoney(float, {
                    symbol: currency,
                    precision: 2,
                    thousand: thousand,
                    decimal: decimal,
                    format: format
                });
            }
            else {
                output = input;
            }
            return output
        }

        /**
         * Contains file upload and delete ajax logic.
         * */
        function fileUpload() {

            // $("#fileuploadProgress").hide();
            $('.fileUploadResult').hide();

            $('.fileUpload').each(function () {
                var $inputElement = $(this);
                var $inputField = $(this).find('input[type=file]');
                var inputFieldId = $($inputField)[0].id;
                var $uploadButton = $(this).find('button');
                var $uploadLabel = $(this).find('label .uploadFileElement');
                var $deleteButton = $(this).find('.inputfileDelete');
                var $result = $(this).find('.fileUploadResult');
                var $uploadFileElement = $(this).find('.uploadFileElement');

                $deleteButton.hide();

                $($inputField).fileupload({
                    url: $('#' + inputFieldId).attr("data-url"),
                    dataType: "json",
                    maxFileSize: $('#' + inputFieldId).attr("data-maxfilesize"),
                    messages: {
                        maxFileSize: $('#' + inputFieldId).attr("data-errormessage")
                    },
                    progressall: function (e, data) {

                        $(".ibsLoadmask").show();
                    },
                    done: function (e, data) {

                        $(".ibsLoadmask").hide();

                        $.each(data.result.files, function (index, file) {

                            if (file.url) {

                                $($result).html("").removeClass('errormessage');
                                $($uploadButton).removeClass("disabled");
                                $($uploadButton).addClass("disabled");
                                $($uploadButton).prop('disabled', true);


                                $('#' + inputFieldId).prop('required', false);

                                $($uploadFileElement).show();

                                if ($('#' + inputFieldId).data("delete-url") != "") {
                                    $($deleteButton).show();

                                    var deleteFunction = function (event) {
                                        event.preventDefault();
                                        $(".ibsLoadmask").show();
                                        $.ajax({
                                            type: "POST",
                                            url: $('#' + inputFieldId).data("delete-url"),
                                            data: {
                                                file: file.name
                                            },
                                            complete: function () {
                                                $($uploadLabel).html($($uploadLabel).data('infotext'));
                                                $(".ibsLoadmask").hide();
                                            }
                                        })
                                            .always(function (data) {
                                                $($uploadButton).removeClass("disabled");
                                                $($uploadButton).prop('disabled', false);
                                                $($deleteButton).hide();
                                                $($uploadFileElement).hide();
                                                $(".ibsLoadmask").hide();
                                            });

                                        //remove handler after firing
                                        $($deleteButton).unbind('click', deleteFunction);
                                    };

                                    $($deleteButton).click(deleteFunction);
                                    $($deleteButton).on("keydown", handleKeyDownForClick);
                                }
                            }
                            else if (file.error) {
                                $($result).html(file.error);
                                $($result).show();
                                $($result).addClass("error");

                                if ($('#' + inputFieldId).data("delete-url") != "") {
                                    $.ajax({
                                        type: "POST",
                                        url: $('#' + inputFieldId).data("delete-url"),
                                        data: {}
                                    }).always(function (data) {
                                        $($uploadButton).removeClass("disabled");
                                        $($uploadButton).prop('disabled', false);

                                    });
                                }
                            }
                        });
                    },
                    destroy: function () {
                        $(".ibsLoadmask").hide();
                    }
                }).on('fileuploadfail', function (e, data) {
                    $(".ibsLoadmask").hide();

                    if (data.result && data.result.files) {
                        $.each(data.result.files, function (index, file) {
                            if (file.error) {
                                $uploadLabel.html('DATEI AUSWAHLEN');
                                $($result).html(file.error);
                                $($result).show();
                                $($result).addClass("error");
                            }
                        });
                    }
                    else {
                        $uploadLabel.html('DATEI AUSWAHLEN');
                        $($result).html(ftc_tr.uploadError);
                        $($result).show();
                        $($result).addClass("error");
                    }

                }).on('fileuploadprocessalways', function (e, data) {
                    var currentFile = data.files[data.index];
                    if (data.files.error && currentFile.error) {
                        // there was an error, do something about it
                        $uploadLabel.html('DATEI AUSWAHLEN');
                        $($result).html(currentFile.error);
                        $($result).show();
                        $($result).addClass("error");
                        consolog(currentFile.error);
                    }

                    $(".ibsLoadmask").hide();
                });

            });
        }

        /**
         *
         * */
        function updateOnFirstPageChange() {

            var result1, result2;
            var $dailycostChecked = $('input[data-group-id=inputDailyCost]:checked');
            var $inputPremium = $('#calcMonthlySelect').find('input');
            var $calcMonthlySection = $('#calcMonthlySelect');
            var v1, v2;
            v1 = $('#inputValueFoodtruck').val().replace(".", "");
            v1 = v1.replace(",", "");
            v2 = $('#inputValueFoodtruckContent').val().replace(".", "");
            v2 = v2.replace(",", "");
            
            var value1, value2;
            //de-DE currency values

            var pageLang = ((document.documentElement.lang || '').toLowerCase()).replace('-', '_');
            if (pageLang === 'de' || pageLang.indexOf('de_') === 0) {
                value1 = parseFloat(v1.replace(/\./gi, '').replace(',', '.'));
                value2 = parseFloat(v2.replace(/\./gi, '').replace(',', '.'));
            } 
            else if (pageLang === 'en' || pageLang.indexOf('en_') === 0) {
                value1 = parseFloat(v1.replace(/,/gi, ''));
                value2 = parseFloat(v2.replace(/,/gi, ''));
            }
            else{
                value1 = parseFloat(v1.replace(/\./gi, '').replace(',', '.'));
                value2 = parseFloat(v2.replace(/\./gi, '').replace(',', '.'));
            }
            
            if(value1){
                $('#inputValueFoodtruck').val(value1);
            }
            if(value2){
                $('#inputValueFoodtruckContent').val(value2);
            }

            var daycosts = !!($($dailycostChecked).length) && parseInt($($dailycostChecked).val());

            //console.log("updateOnFirstPageChange # value1:" + value1 + " # value2:" + value2 + " # daycosts:" + daycosts);

            if (!value1 || !value2 || (daycosts === false)) {
                //blank result - reset form page if input removed
                result1 = 0;
                result2 = 0;
                $($page1).find('button.next').prop('disabled', true);
                $($inputPremium).parentsUntil('.row').find(':checked').prop('checked', false);
                $($inputPremium).prop('disabled', true);
                $($calcMonthlySection).addClass('disabled');
            }
            else {
                // enable monthly premium selection
                $($inputPremium).prop('disabled', false);
                $($calcMonthlySection).removeClass('disabled');

                // calculate premiums
                var sum = (value1 + (10 * daycosts)) / 12;
                var factor1000 = dataContainerObj['kasko1000']['factor'][dataContainerObj.getType()];
                var factor500 = dataContainerObj['kasko500']['factor'][dataContainerObj.getType()];
                result1 = Math.round(((sum * factor500) / 100) * 100) / 100;

                result2 = Math.round(((sum * factor1000) / 100) * 100) / 100;
            }

            //store values
            dataContainerObj['kasko500']['value'] = parseFloat(result1);
            dataContainerObj['kasko1000']['value'] = parseFloat(result2);
            dataContainerObj['kasko500']['currency'] = formatNumberToCurrency(result1, 'name', dataContainerObj.getLang(), dataContainerObj.getCurrency());
            dataContainerObj['kasko1000']['currency'] = formatNumberToCurrency(result2, 'name', dataContainerObj.getLang(), dataContainerObj.getCurrency());

            //display values for premium selctions formatted
            $('#inputPremium500').next('.label-headline').html(dataContainerObj['kasko500']['currency'].toUpperCase());
            $('#inputPremium1000').next('.label-headline').html(dataContainerObj['kasko1000']['currency'].toUpperCase());
        }

        /**
         *
         * */
        function updateOnPremiumSelect() {
            var $selected;
            if ($selected = $('#calcMonthlySelect').find('input').filter(function () {
                    return $(this).prop('checked');
                })) {
                $($page1).find('button.next').prop('disabled', false);
                dataContainerObj['totals'] = dataContainerObj['totals'] || {};
                dataContainerObj['totals'].kasko = dataContainerObj['kasko' + $($selected).val()].value;
                var $total = $($page3).find('.optionElement .ftcKasko .totalAmount').html(formatNumberToCurrency((dataContainerObj['totals'].kasko * 12), 'symbol', dataContainerObj.getLang(), dataContainerObj.getCurrency() ));
                updateCalculationSummary();
            }

        }

        /**
         *
         * */
        function updateOnSecondPageChange() {

            var $options = $('#ftcOptionsSelectContainer').find('input[type=checkbox]');
            var $optionContainer = $('#ftcDynamicOptionsContainer');
            var optionsSum = 0;

            // template option element
            var $optionElement = $('<div class="optionElement"><p class="optionName"></p><div class="row optionTotal"><div class="col-sm-4 totalLabel">'
                + ftc_tr.annualAmount
                + '</div><div class="col-sm-5 col-sm-offset-1 totalAmount"></div></div></div>');

            // reset container
            $($optionContainer).html('');

            //rebuild options elements
            $($options).each(function (index, el) {
                if (el.checked) {
                    var data = {};

                    // get label for input (translated content)
                    // strip span tag (contains tooltip icon)
                    data.optionName = $(el).parent('label').find('p:first').html().replace(/(<spa)n.+/, '');
                    data.totalAmount = $(el).data('option-amount');

                    var $option = $($optionElement).clone();
                    $($option).find('.optionName').html(data.optionName);
                    $($option).find('.totalAmount').html(formatNumberToCurrency(data.totalAmount , 'symbol', dataContainerObj.getLang(), dataContainerObj.getCurrency() ));

                    $($optionContainer).append($option);

                    //add to options total to update final summary
                    !isNaN(parseFloat(data.totalAmount)) && (optionsSum += parseFloat(data.totalAmount));
                    // reset temp element
                    $option = '';
                }
                if( 'kfzHaftpflicht' === $(el)[0].id ) {
                    var $kfzVersicherungUpload = $foodtruckForm.find('#aktVersicherungRechnung');
                    $kfzVersicherungUpload.prop('required', false);
                    if($(el).prop('checked')){
                        $kfzVersicherungUpload.parent().css('display','block');
                        //$kfzVersicherungUpload.prop('required', true);
                    } else {
                        $kfzVersicherungUpload.parent().css('display','none');
                        //$kfzVersicherungUpload.prop('required', false);
                    }
                }
            });
            dataContainerObj.totals.options = optionsSum;
            updateCalculationSummary();

        }
    }
}
